import { Check, AlertCircle } from "lucide-react";
import { cn } from "../../../lib/utils";

export function LeaveActionToast({ toast }) {
  if (!toast) return null;

  return (
    <div className="fixed bottom-5 right-5 z-50 animate-in fade-in slide-in-from-bottom-5 duration-300 pointer-events-none">
      <div
        className={cn(
          "flex items-start gap-2.5 bg-white border text-foreground px-4 py-3 rounded-2xl shadow-[0_15px_40px_-10px_rgba(30,51,131,0.25)] font-sans text-sm font-medium max-w-sm",
          toast.type === "error"
            ? "border-error/30"
            : "border-(--color-text-border)/60"
        )}
      >
        <div
          className={cn(
            "h-6 w-6 rounded-full grid place-items-center shrink-0 mt-0.5",
            toast.type === "error"
              ? "bg-error/10 text-error"
              : "bg-success/10 text-success"
          )}
        >
          {toast.type === "error" ? (
            <AlertCircle className="h-4 w-4" />
          ) : (
            <Check className="h-4 w-4" />
          )}
        </div>
        <div>
          <span>{toast.message}</span>
          {toast.detail ? (
            <span className="block text-xs font-normal per-file-hint mt-1">
              {toast.detail}
            </span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
